<template>
  <TileDataContent
    :fids="fids"
    :forecast-label="forecastLabel"
    :dataset="dataset"
    :data-by-id="dataById"
  >
    <template #content-header>
      <TileDataContentHeader>
        <template #second-column>
          {{ $t('components.map.tiles.OMLogistics.eVans') }}
        </template>
        <template #third-column>
          {{ $t('components.map.tiles.OMLogistics.eTruck') }}
        </template>
      </TileDataContentHeader>
    </template>

    <template #content="{ showData }">
      <!-- COUNT -->
      <TileDataContentRowThreeColumn>
        <template #first-column>
          {{ $t('components.map.tiles.OMLogistics.evs') }}
        </template>
        <template #second-column>
          {{ showData({field: `e-bestel_tot_${year}`, decimals: 0}) }}
        </template>
        <template #third-column>
          {{ showData({field: `e-trucks_${year}`, decimals: 0}) }}
        </template>
      </TileDataContentRowThreeColumn>

      <br>

      <!-- Publiek -->
      <TileDataContentGroupThreeColumn>
        <template #header>
          {{ $t('accessibility.public') }}
        </template>

        <TileDataContentRowThreeColumn>
          <template #first-column>
            {{ $t('components.map.tiles.OMLogistics.vehicles') }}
          </template>
          <template #second-column>
            {{ showData({field: `e-bestel_pub_${year}`, decimals: 1}) }}
          </template>
          <template #third-column>
            -
          </template>
        </TileDataContentRowThreeColumn>
        <TileDataContentRowThreeColumn>
          <template #first-column>
            {{ $t('components.map.tiles.TileData.chargingStations') }}
          </template>
          <template #second-column>
            {{ showData({field: `ldpt_e-bestel_pub_${year}`, decimals: 2}) }}
          </template>
          <template #third-column>
            -
          </template>
        </TileDataContentRowThreeColumn>
      </TileDataContentGroupThreeColumn>

      <!-- DEPOT -->
      <TileDataContentGroupThreeColumn>
        <template #header>
          {{ $t('components.map.tiles.OMLogistics.depot') }}
        </template>

        <TileDataContentRowThreeColumn>
          <template #first-column>
            {{ $t('components.map.tiles.TileData.EV') }}
          </template>
          <template #second-column>
            {{ showData({field: `e-bestel_depot_${year}`, decimals: 0}) }}
          </template>
          <template #third-column>
            -
          </template>
        </TileDataContentRowThreeColumn>
        <TileDataContentRowThreeColumn>
          <template #first-column>
            {{ $t('components.map.tiles.TileData.chargingStations') }}
          </template>
          <template #second-column>
            {{ showData({field: `ldpt_e-bestel_depot_${year}`, decimals: 1}) }}
          </template>
          <template #third-column>
            {{ showData({field: `ldpt_e-trucks_depot_tot_${year}`, decimals: 1}) }}
          </template>
        </TileDataContentRowThreeColumn>

        <TileDataContentRowThreeColumn>
          <template #first-column>
            50-150 kW
          </template>
          <template #second-column>
            -
          </template>
          <template #third-column>
            {{ showData({field: `ldpt_e-trucks_50-150kw_${year}`, decimals: 2}) }}
          </template>
        </TileDataContentRowThreeColumn>
        <TileDataContentRowThreeColumn>
          <template #first-column>
            > 150 kW
          </template>
          <template #second-column>
            -
          </template>
          <template #third-column>
            {{ showData({field: `ldpt_e-trucks_>150kw_${year}`, decimals: 2}) }}
          </template>
        </TileDataContentRowThreeColumn>
      </TileDataContentGroupThreeColumn>

      <TileDataContentRowThreeColumn>
        <template #first-column>
          {{ $t('components.map.tiles.OMLogistics.unit') }}
        </template>
        <template #second-column>
          {{ showData({field: `mwj_e-bestel_depot_${year}`, decimals: 0}) }}
        </template>
        <template #third-column>
          {{ showData({field: `mwj_e-trucks_depot_${year}`, decimals: 0}) }}
        </template>
      </TileDataContentRowThreeColumn>
    </template>

    <template #footer>
      ID: {{ fids[0] }}
    </template>
  </TileDataContent>
</template>

<script>
import TileDataContent from '@/components/map/tiles/TileDataContent'
import TiledataMixin from '@/mixins/map/tiledata-mixin'
import TileDataContentHeader from '@/components/map/tiles/TileDataContentHeader'
import TileDataContentRowThreeColumn from '@/components/map/tiles/TileDataContentRowThreeColumn'
import TileDataContentGroupThreeColumn from '@/components/map/tiles/TileDataContentGroupThreeColumn'

export default {
  name: 'TileDataOMLogistics',
  components: { TileDataContentGroupThreeColumn, TileDataContentRowThreeColumn, TileDataContentHeader, TileDataContent },
  mixins: [TiledataMixin],

}
</script>
